import client from './client';

export interface TakeoutMenu {
  id: string;
  storeId: string;
  name: string;
  description: string | null;
  category: string | null;
  price: number;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateMenuPayload {
  name: string;
  description?: string | null;
  category?: string | null;
  price: number;
  isActive?: boolean;
  displayOrder?: number;
}

export type UpdateMenuPayload = Partial<CreateMenuPayload>;

export async function listTakeoutMenus(
  storeId: string,
  includeInactive = true,
): Promise<TakeoutMenu[]> {
  const res = await client.get<TakeoutMenu[]>(
    `/api/stores/${storeId}/takeout-menus`,
    { params: { includeInactive: includeInactive ? 'true' : 'false' } },
  );
  return res.data;
}

export async function createTakeoutMenu(
  storeId: string,
  payload: CreateMenuPayload,
): Promise<TakeoutMenu> {
  const res = await client.post<TakeoutMenu>(
    `/api/stores/${storeId}/takeout-menus`,
    payload,
  );
  return res.data;
}

export async function updateTakeoutMenu(
  storeId: string,
  id: string,
  payload: UpdateMenuPayload,
): Promise<TakeoutMenu> {
  const res = await client.patch<TakeoutMenu>(
    `/api/stores/${storeId}/takeout-menus/${id}`,
    payload,
  );
  return res.data;
}

export async function deleteTakeoutMenu(
  storeId: string,
  id: string,
): Promise<{ success: true }> {
  const res = await client.delete<{ success: true }>(
    `/api/stores/${storeId}/takeout-menus/${id}`,
  );
  return res.data;
}

export async function seedDefaultTakeoutMenus(
  storeId: string,
): Promise<TakeoutMenu[]> {
  const res = await client.post<TakeoutMenu[]>(
    `/api/stores/${storeId}/takeout-menus/seed-default`,
  );
  return res.data;
}
